import { getNextElement, getPreviousElement } from 'office-ui-fabric-react';

/**
 * Handles Tab key on elements where we want to skip tabbing to the children elements
 */
export const handleTabOnUXElements = (event: React.KeyboardEvent<HTMLDivElement>) => {
  if (event.currentTarget !== event.target) {
    return;
  }

  if (event.shiftKey) {
    const previousElement = getPreviousElement(
      /*rootElement*/ document.body,
      /*currentElement*/ event.currentTarget,
      /*checkNode*/ undefined,
      /*suppressParentTraversal*/ undefined,
      /*traverseChildren*/ false,
      /*includeElementsInFocusZones*/ true,
      /*allowFocusRoot*/ undefined,
      /*tabbable*/ true
    );

    previousElement?.focus();
  } else {
    const nextElement = getNextElement(
      /*rootElement*/ document.body,
      /*currentElement*/ event.currentTarget,
      /*checkNode*/ undefined,
      /*suppressParentTraversal*/ undefined,
      /*suppressChildTraversal*/ true,
      /*includeElementsInFocusZones*/ true,
      /*allowFocusRoot*/ undefined,
      /*tabbable*/ true
    );

    nextElement?.focus();
  }

  event.preventDefault();
};
